import { Module } from "wrapper6";
import Glide from '@glidejs/glide'

export default class FeatureClickables extends Module {
  ready() {
    this.SLIDER_WRAPPERS = document.querySelectorAll('.mtt-features-modal-wrap');
    this.IMAGE_WRAPPER = document.querySelector('.mtt-features-modal__image');
    this.SLIDER_NEXT = '.mtt-features-modal__next';
    this.SLIDER_PREV = '.mtt-features-modal__prev';
    this.hasHeight = false;

    // modal image slider
    this.touchstartX = 0;
    this.touchstartY = 0;
    this.touchendX = 0;
    this.touchendY = 0;

    if (this.SLIDER_WRAPPERS) {
      this.initSliders();
    }
  }

  initSliders() {
    for (let i = 0; i < this.SLIDER_WRAPPERS.length; i++) {
      const SLIDER_WRAP = this.SLIDER_WRAPPERS[i];

      const SLIDER_ELEMENT = SLIDER_WRAP.querySelector('.glide');
      const NEXT_ARROW = SLIDER_WRAP.querySelector(this.SLIDER_NEXT);
      const PREV_ARROW = SLIDER_WRAP.querySelector(this.SLIDER_PREV);

      const SLIDER = new Glide(SLIDER_ELEMENT, {
        type: 'carousel',
        perView: 1
      });

      NEXT_ARROW.addEventListener('click', () => SLIDER.go('>'));
      PREV_ARROW.addEventListener('click', () => SLIDER.go('<'));

      SLIDER.mount();

      this.resetImage(SLIDER_WRAP);
      this.initBullets(SLIDER_WRAP, SLIDER);
      this.handleModal(SLIDER);
      this.resizeHandler();
      this.loadAllImages();
      this.modalImageSlide(SLIDER);
    }

    window.addEventListener('resize', () => this.resizeHandler(), false);
  }

  modalImageSlide(slider) {
    
    this.IMAGE_WRAPPER.addEventListener('touchstart', (event) => {
      this.touchstartX = event.changedTouches[0].screenX;
      this.touchstartY = event.changedTouches[0].screenY;
    }, false);
    
    this.IMAGE_WRAPPER.addEventListener('touchend', (event) => {
      this.touchendX = event.changedTouches[0].screenX;
      this.touchendY = event.changedTouches[0].screenY;
      this.handleGesture(slider);
    }, false); 
  }

  handleGesture(slider) {
    if (this.touchendX <= this.touchstartX) {
      slider.go('>');
    }
    
    if (this.touchendX >= this.touchstartX) {
      slider.go('<');
    }
  }

  initBullets(sliderWrap, slider) {
    const BULLETS = sliderWrap.querySelectorAll('.mtt-features-modal__bullet');

    for (let i = 0; i < BULLETS.length; i++) {
      const BULLET = BULLETS[i];

      BULLET.addEventListener('click', e => {
        slider.go(`=${e.target.getAttribute('data-bullet-id')}`);
      })
    }

    slider.on('run', () => {
      sliderWrap.querySelector(`.mtt-features-modal__bullet--active`).classList.remove('mtt-features-modal__bullet--active');
      sliderWrap.querySelector(`[data-bullet-id="${slider.index}"]`).classList.add('mtt-features-modal__bullet--active');
      sliderWrap.querySelector(`img`).setAttribute('src', sliderImages[slider.index]);
    });
  }

  resetImage(sliderWrap) {
    const IMG = sliderWrap.querySelector('.mtt-features-modal__image img');
    if (IMG.hasAttribute('srcset')) { IMG.removeAttribute('srcset') }
    if (IMG.hasAttribute('alt')) { IMG.removeAttribute('alt') }
    if (IMG.hasAttribute('sizes')) { IMG.removeAttribute('sizes') }
    if (IMG.hasAttribute('class')) { IMG.removeAttribute('class') }
    if (IMG.hasAttribute('width')) { IMG.removeAttribute('width') }
    if (IMG.hasAttribute('height')) { IMG.removeAttribute('height') }
  }

  loadImage(imgSrc) {
    const IMAGE = new Image;

    IMAGE.onload = function() {}

    IMAGE.src = imgSrc;
  }

  loadAllImages() {
    for (let i = 0; i < sliderImages.length; i++) {
      const SLIDER_IMG = sliderImages[i];
      this.loadImage(SLIDER_IMG);
    }
  }

  handleModal(slider) {
    const LIST_ITEMS = document.querySelectorAll('.overview-click, .feature-number');

    for (let i = 0; i < LIST_ITEMS.length; i++) {
      const LIST_ITEM = LIST_ITEMS[i];

      LIST_ITEM.addEventListener('click', e => {
        slider.go(`=${e.currentTarget.getAttribute('data-id')}`);
        this.openModal();
      });
    }

    document.querySelector('.mtt-features-modal-wrap').addEventListener('click', e => {
      if (e.target.classList.contains('mtt-features-modal-wrap__content') || e.target.classList.contains('mtt-features-modal-wrap')) {
        this.closeModal();
      }
    });

    document.querySelector('.mtt-features-modal__close').addEventListener('click', () => {
      this.closeModal();
    });

    document.addEventListener("keydown", event => event.which === 27 && this.modalIsOpen() ? this.closeModal() : false);
  }

  modalIsOpen() {
    return document.querySelector('.mtt-features-modal-wrap--open');
  }

  openModal() {
    document.querySelector('.mtt-features-modal-wrap').classList.add('mtt-features-modal-wrap--open');
  }

  closeModal() {
    document.querySelector('.mtt-features-modal-wrap').classList.remove('mtt-features-modal-wrap--open');
  }

  resizeHandler() {
    const IMAGE_WRAP = document.querySelector('.mtt-features-modal__image');
    if (!IMAGE_WRAP) return;

    const TEXT_WRAP = document.querySelectorAll('.mtt-features-modal__slide > div');
    const IMAGE_WRAP_HEIGHT = IMAGE_WRAP.offsetHeight;
    const WINDOW_WIDTH = window.innerWidth;
    
    if (WINDOW_WIDTH <= 1000) {
      for (let i = 0; i < TEXT_WRAP.length; i++) {
        const EL = TEXT_WRAP[i];
        EL.style.height = `calc(100vh - ${IMAGE_WRAP_HEIGHT}px)`;
      }

      this.hasHeight = true;
    }

    if (this.hasHeight && WINDOW_WIDTH > 1000) {
      for (let i = 0; i < TEXT_WRAP.length; i++) {
        const EL = TEXT_WRAP[i];
        EL.style.height = '';
      }

      this.hasHeight = false;
    }
  }
}